export interface Rollouts {
    [key: string]: boolean;
}

// //////////////////////////////////
// PLEASE KEEP ALPHABETICAL ORDER
// //////////////////////////////////
export const ROLLOUTS = {
    CARIBOU_GIG_REPORT_ELIGIBILITY: 'caribou_gig_report_eligibility',
    CHAM_GIG_PAGE_LAZY_LOAD_PCP: 'cham_gig_page_lazy_load_pcp',
    CHEETAHS_GIG_PAGE_DATA_GQL: 'cheetahs_gig_page_data_gql',
    CHEETAHS_GIG_PAGE_DQA: 'cheetahs_gig_page_dqa',
    COBRAS_OPEN_HOURLY_TO_MP: 'cobras_open_hourly_to_mp',
    DSA_COMPLIANCE_FOR_EU_CONSUMERS: 'dsa_compliance_for_eu_consumers',
    FOXES_GIG_PAGE_RENDER_DELAY_MESSAGE: 'foxes_gig_page_render_delay_message',
    HAWKS_ADD_TIMEOUT_TO_ADDITIONAL_DATA: 'hawks_add_timeout_to_additional_data',
    HAWKS_DQA_INTEGRATION_FIRST_PHASE: 'hawks_dqa_integration_first_phase',
    LIONS_MT_CALL_ON_SSR_CRAWLERS: 'lions_machine_translation_call_on_ssr_crawlers',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_DE: 'lions_machine_translation_call_on_ssr_real_users_de',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_ES: 'lions_machine_translation_call_on_ssr_real_users_es',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_FR: 'lions_machine_translation_call_on_ssr_real_users_fr',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_IT: 'lions_machine_translation_call_on_ssr_real_users_it',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_NL: 'lions_machine_translation_call_on_ssr_real_users_nl',
    LIONS_MT_CALL_ON_SSR_REAL_USERS_PT: 'lions_machine_translation_call_on_ssr_real_users_pt',
    LYNXES_GIG_PAGE_CTA_REWORK: 'lynxes_gig_page_cta_rework',
    MARLINS_GIG_PAGE_DES_BANNER: 'marlins_gig_page_des_banner',
    MARLINS_GIG_PAGE_MULTI_BANNER: 'marlins_gig_page_multi_banner',
    MARLINS_GIG_PAGE_PJM_BANNER: 'marlins_gig_page_pjm_banner',
    MEERKATS_AI_SUMMARY: 'meerkats_ai_summary',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
    PIGLETS_GIG_PAGE_PAYPAL_PAYLATER_MESSAGE: 'piglets_gig_page_paypal_paylater_message', // we cannot delete rollout until the contract with PayPal expires
    QUALAS_GIG_PAGE_WORK_SAMPLES: 'qualas_gig_page_work_samples',
    STARLINGS_BOOSTING_NEW_GIGS: 'starlings_boosting_new_gigs',
    ZEBRAS_CREATE_AI_BRIEF_ON_GIG_PAGE: 'zebras_create_ai_brief_on_gig_page',
};

export const KILL_SWITCH_ROLLOUTS = {
    HAWKS_INFRA_LOG_UNKNOWN_CRAWLERS_ON_GIG_PAGE: 'hawks_infra_log_unknown_crawlers_on_gig_page',
};
